/**
 * @generated SignedSource<<df226fe979ad4e698a5f3b9917dcdcf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
import { FragmentRefs } from "relay-runtime";
export type ProductLinkedTodosFloatingAddButton_Store$data = {
  readonly todoCategories: ReadonlyArray<{
    readonly icon: TodoCategoryIcon | null;
    readonly id: string;
    readonly title: string;
  }>;
  readonly " $fragmentType": "ProductLinkedTodosFloatingAddButton_Store";
};
export type ProductLinkedTodosFloatingAddButton_Store$key = {
  readonly " $data"?: ProductLinkedTodosFloatingAddButton_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductLinkedTodosFloatingAddButton_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductLinkedTodosFloatingAddButton_Store",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeDefault",
          "value": true
        }
      ],
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "todoCategories",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        }
      ],
      "storageKey": "todoCategories(includeDefault:true)"
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "432fc3a6a757769705c9cfb8e21b8ca4";

export default node;
